import {
  Alert,
  FormControlLabel,
  Radio,
  RadioGroup,
  Step,
  StepLabel,
  Stepper,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ContactContext } from "../../../context/contact/ContactContext";
import { VendorContext } from "../../../context/vendor/VendorContext";
import Wait from "../../Wait";
import LegalPerson from "./legalPerson";
import NaturalPerson from "./naturalPerson";
import { ColumnButtons } from "./naturalPerson/style";
import stylesCss, {
  Root,
  Container,
  Tittle,
  Column,
  Button,
  CssNativeSelect,
  OptionSelect,
} from "./style";

const Enrollment = () => {
  const { t } = useTranslation();
  // const [showContinueInfo, setShowContinueInfo] = useState(false);
  const optionTypePerson = [
    { value: 1, label: "naturalPerson" },
    { value: 2, label: "legalPerson" },
  ];
  const classesSx = stylesCss;
  const {
    activeStep,
    steps,
    listCountry,
    vendFlowEnrollment,
    vendorInformation,
    setActiveStep,
    setVendorInformation,
    getSteps,
    getVendFlowEnrollment,
    getDataEnrollment,
    getListCountry,
    sendVendorInformation,
    sendVendFlowEnrollment,
  } = useContext(VendorContext);

  const { company } = useContext(ContactContext);
  const [isLoading, setLoading] = useState(true);
  const handleNext = async () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = async () => {
    setActiveStep(activeStep - 1);
  };
  const handleCountryInformation = (event, tag) => {
    event.preventDefault();
    vendorInformation[event.target.name] = event.target.value;
    setVendorInformation(vendorInformation);
  };
  const submitFormCountry = async (event) => {
    event.preventDefault();
    if (vendorInformation.country !== "ECU") {
      vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 2;
      await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
      await Promise.all([sendVendorInformation(vendorInformation)]);
      setActiveStep(activeStep + 2);
    } else {
      if (vendFlowEnrollment.lasT_STEP === activeStep) {
        vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
        await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
        await Promise.all([sendVendorInformation(vendorInformation)]);
      }
      handleNext();
    }
  };
  const handleRadioChange = (event) => {
    vendorInformation[event.target.name] = event.target.value;
    console.log(vendorInformation.type);
    setVendorInformation(vendorInformation);
  };
  const handleSubmitTypePerson = async (event) => {
    event.preventDefault();
    if (vendFlowEnrollment.lasT_STEP === activeStep) {
      vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
      await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
      await Promise.all([sendVendorInformation(vendorInformation)]);
    }
    handleNext();
  };
  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendFlowEnrollment()]);
      await Promise.all([
        getDataEnrollment(company),
        getSteps(vendorInformation.type),
      ]);
      setLoading(false);
    };
    fetchData2();
  }, []);
  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.company !== "") {
        await Promise.all([getListCountry(vendorInformation.company)]);
      }
      if (vendFlowEnrollment.lasT_STEP === activeStep) {
        document.getElementsByName("type").disabled = true;
      }
    };
    fetchData2();
  }, [vendorInformation]);

  useEffect(() => {
    getSteps(vendorInformation.type);
  }, [vendorInformation.type]);
  // useEffect(() => {
  //   if (vendFlowEnrollment.lasT_STEP > -1) {
  //     setShowContinueInfo(true);
  //     setTimeout(() => {
  //       // After 3 seconds set the show value to false
  //       setShowContinueInfo(false);
  //     }, 3000);
  //   }
  // }, [vendFlowEnrollment]);
  if (isLoading) {
    return <Wait />;
  }
  return (
    <>
      {/* {showContinueInfo && (
        <Alert variant="filled" severity="info">
          Continúa desde donde los dejaste
        </Alert>
      )} */}
      <Root>
        {activeStep > 0 && (
          <Stepper sx={classesSx.root} activeStep={activeStep - 1}>
            {steps.map((label, index) => {
              return (
                <Step key={label}>
                  <StepLabel>{/* {label} {index} */}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        )}
        {activeStep === -1 && (
          <form
            onSubmit={(e) => {
              submitFormCountry(e);
            }}
          >
            <Tittle>{t("selectCountry")}</Tittle>
            <Container>
              <Column>
                <CssNativeSelect
                  value={vendorInformation.country}
                  name="country"
                  onChange={(e) => handleCountryInformation(e, 1)}
                >
                  {listCountry.map((item, index) => (
                    <OptionSelect key={index} value={item.countryRegionId}>
                      {item.shortName}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </Column>
            </Container>
            <Button>{t("next")}</Button>
          </form>
        )}
        {activeStep === 0 && (
          <>
            <Tittle>{t("selectTypePerson")}</Tittle>
            <form onSubmit={handleSubmitTypePerson} disabled>
              <Container>
                <Column>
                  <RadioGroup
                    value={vendorInformation.type}
                    name="type"
                    onChange={handleRadioChange}
                    sx={classesSx.radioGroup}
                  >
                    {optionTypePerson.map((person, index) => {
                      return (
                        <FormControlLabel
                          key={index}
                          value={person.value}
                          control={
                            <Radio
                              required={!vendorInformation.type}
                              sx={classesSx.radio}
                            />
                          }
                          label={t(person.label)}
                        />
                      );
                    })}
                  </RadioGroup>
                  <br />
                </Column>
              </Container>
              <Container>
                <ColumnButtons>
                  <Button onClick={handleBack}>{t("back")}</Button>
                </ColumnButtons>
                <ColumnButtons>
                  <Button>{t("next")}</Button>
                </ColumnButtons>
              </Container>
            </form>
          </>
        )}
        {activeStep > 0 && <NaturalPerson />}
        {/* {vendorInformation.type === "1" && activeStep > 0 && <NaturalPerson />}
        {vendorInformation.type === "2" && activeStep > 0 && <LegalPerson />} */}
      </Root>
    </>
  );
};

export default Enrollment;
